import {VOICE_CHARACTERS} from './modSchema.js';

export const DEFAULT_BLOOD_COLOR = '#c90808';
export const CHARACTER_BLOOD_COLORS = Object.freeze(Object.fromEntries(VOICE_CHARACTERS.map(({slug}) =>
    [slug, slug === 'xenot' ? '#65d62e' : slug === 'crashy' ? '#30251b' : DEFAULT_BLOOD_COLOR])));
export const RAINBOW_BLOOD_COLORS = Object.freeze([
    '#ff355e', '#ff9f1c', '#ffe600', '#61ff3f', '#00d9ff', '#a84dff', '#ff4fda',
]);
export const RAINBOW_BLOOD_INTERVAL = 0.1; // Seconds per color, independent of particle count.

export function normalizeBloodColor(value) {
    return typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value) ? value.toLowerCase() : null;
}

export function characterBloodColor(skin, theme) {
    const slug = VOICE_CHARACTERS[skin]?.slug;
    try {
        if (typeof theme === 'string') theme = JSON.parse(theme);
        const color = normalizeBloodColor(theme?.bloodColors?.[slug]);
        if (color) return color;
    } catch { /* Old or incomplete themes keep the character's default. */ }
    return CHARACTER_BLOOD_COLORS[slug] || DEFAULT_BLOOD_COLOR;
}

export function bloodColorRamp(color) {
    color = normalizeBloodColor(color) || DEFAULT_BLOOD_COLOR;
    const end = color === DEFAULT_BLOOD_COLOR ? '#570101' : '#' + color.slice(1).match(/../g)
        .map(channel => Math.round(parseInt(channel, 16) * 0.4).toString(16).padStart(2, '0')).join('');
    return {start: color, end};
}

export function rainbowBloodColor(seconds) {
    const index = Math.floor(Math.max(0, seconds) / RAINBOW_BLOOD_INTERVAL + 1e-8) % RAINBOW_BLOOD_COLORS.length;
    return RAINBOW_BLOOD_COLORS[index];
}
